<template>
	<div class="poll-main-container"
		:style="`background-color:${$appColors.white}`"
	>
		<section class="poll-header"
			:style="`border-color:${$appColors.gray}`"
		>
			<span 
				class="poll-name"
				:style="`color:${$appColors.primary}`"
				v-if="filterDiagnostic === 1"
			>{{question.name}}</span>
			<span class="poll-name"
				v-if="filterDiagnostic === 2"
				:style="`color:${$appColors.primary}`"
				>{{question.name}} - {{ employee.name }} {{ employee.lastName }} - {{ employee && employee.job ? employee.job.name : '' }}</span>
			<div class="progress-container">
				<progress-bar-component v-model="pollData.progress" :quantity="quantity"/>
			</div>
		</section>
		<section class="poll-questions">
			<question-component
				@selected-icon="selectedPolls"
				v-for="(question, index) in question.details"
				:class="[
					'question-children',
					{ 'display-grid': index <= pollData.progress }
				]"
				:style="`border-color:${$appColors.gray}`"
				:order="index + 1"
				:key="index + 1"
				:ref="`question-${index}`"
				:question="question"
			/>
		</section>
		<send-poll-btn
			@create="createPoll()"
			:disabled="!disabled || btnDisabled"
		/>
	</div>
</template>
<script>
import helper from '@/shared/helper';
import { mapState } from 'vuex';

const { getLocalData } = helper;

function getId() {
	this.id = this.$route.params.id;
}

function selectedPolls(id, questionId) {
	this.question.details = this.question.details.map((r) => {
		const newRow = { ...r };
		if (r.questionId === questionId) {
			newRow.answer.details = r.answer.details.map((p) => {
				const newDetail = { ...p };
				newDetail.isSelected = p.id === id;
				return newDetail;
			});
		}
		return newRow;
	});
}

async function createPoll() {
	const body = this.question.details.map((d) => {
		const value = d.answer.details.filter(e => e.isSelected)[0].value;
		const newDetail = {
			questionId: d.question.id,
			value,
			state: this.question.state,
			hierarchyCount: d.question.entityType.number,
		};
		return newDetail;
	});
	const { id, filter, employee } = this.$route.params;
	const diagnosticId = this.question.diagnosticId;
	const pollId = this.question.details[0].pollId;
	const employeeId = getLocalData('praktiko-user').id;
	try {
		if (filter === 1) {
			await this.$http.post(`poll-employees/${diagnosticId}/${pollId}/${employeeId}`, body);
		} else if (filter === 2) {
			this.btnDisabled = true;
			await this.$http.post(`poll-employees/${id}/${pollId}/${employeeId}/${employee.id}`, body);
		}
		this.showNotification('La encuesta se creó correctamente.');
		this.btnDisabled = false;
		this.goTo('survey');
	} catch (error) {
		if (error.status === 400) {
			if (error.data.message === 'DIAGNOSTIC_TIME_OUT' || error.data.message === 'PROCESS_TIME_OUT') {
				this.showGenericError('El tiempo para realizar la encuesta ha finalizado.');
			} else if (error.data.message === 'REPORT_DATA_ERROR_DIAGNOSTIC_DETAIL') {
				this.showGenericError('La encuesta ya fue enviada.');
			}
		} else {
			this.showGenericError();
		}
	}
}

function created() {
	const [body] = window.document.getElementsByTagName('body');
	body.classList.add('survey-page');
	this.$nextTick(() => {
		if (this.$parent && this.$parent.$slots && this.$parent.$slots.default) {
			this.$parent.$slots.default[0].children[4].elm.classList.add('on-survey');
			this.$parent.$slots.default[0].children[4].elm.classList.remove('section-margin');
		}
	});
	this.filterDiagnostic = this.$route.params.filter;
	this.listQuestion();
	this.getId();
}

async function listQuestion() {
	try {
		const { id, filter, employee } = this.$route.params;
		if (filter === 1) {
			const response = await this.$http.get(`poll-employees/${id}/detail`);
			this.question = response.data;
			this.question.details = response.data.details.map((r) => {
				const newRow = { ...r };
				newRow.answer.details = r.answer.details.map((p) => {
					const newDetail = { ...p };
					newDetail.isSelected = false;
					return newDetail;
				});
				return newRow;
			});
		} else if (filter === 2) {
			const params = {
				params: {
					jobId: employee.jobId,
				},
			};
			this.employee = employee;
			const response = await this.$http.get(`poll-employees/${id}/process-detail`, params);
			this.question = response.data;
			this.question.details = response.data.details.map((r) => {
				const newRow = { ...r };
				newRow.answer.details = r.answer.details.map((p) => {
					const newDetail = { ...p };
					newDetail.isSelected = false;
					return newDetail;
				});
				return newRow;
			});
		}
	} catch (error) {
		this.showGenericError();
	}
}

function beforeDestroy() {
	this.$store.commit('RESET_POLL_PROGRESS');
	const [body] = window.document.getElementsByTagName('body');
	body.classList.remove('survey-page');
}

function quantity() {
	return this.question.details.length;
}

function disabled() {
	return this.pollData.progress === this.quantity;
}

function progressChange(val) {
	const self = this;
	setTimeout(() => {
		const [element] = self.$refs[`question-${val - 1}`];
		const el = element.$el;
		const heigthEl = el.offsetHeight;
		self.top += (heigthEl);
		window.scroll({
			top: self.top,
			left: 100,
			behavior: 'smooth',
		});
	}, 400);
}

function data() {
	return {
		dataSelected: [],
		selected: null,
		id: null,
		question: {
			details: [],
		},
		employee: null,
		top: 65,
		filterDiagnostic: null,
		btnDisabled: false,
	};
}
export default {
	name: 'page-polls',
	beforeDestroy,
	components: {
		progressBarComponent: () => import('polls/progress-bar-component'),
		questionComponent: () => import('polls/question-component'),
		sendPollBtn: () => import('polls/send-poll-btn'),
	},
	computed: {
		...mapState({
			pollData: state => state.pollData,
		}),
		quantity,
		disabled,
	},
	created,
	data,
	methods: {
		createPoll,
		getId,
		listQuestion,
		selectedPolls,
		progressChange,
	},
	watch: {
		'pollData.progress': progressChange,
	},
};
</script>
<style lang="scss" scoped>
	.poll-header {
		align-items: center;
		background-color: color(gray-light);
		border-bottom: 1px solid;
		display: flex;
		height: 65px;
		justify-content: space-between;
		left: 0;
		padding-left: 157px;
		padding-right: 111px;
		position: fixed;
		top: 72px;
		width: 100%;
		z-index: 2;

		@media (max-width: 768px) {
			flex-direction: column;
			height: auto;
			padding: 20px 0;
		}
	}

	.poll-name {
		font-family: font(bold);
		font-size: size(xlarge);
		transform: translateX(75px);
	}

	.poll-main-container {
		margin-top: 117px;
		padding-bottom: 117px;
		@media (max-width: 768px) {
			background-color: transparent;
			width: 460px;
			overflow-x:scroll;
    	overflow-y:hidden;
		}
	}

	.progress-container {
		margin-top: 20px;
		width: 270px;

		@media (max-width: 768px) {
			margin-top: 8px;
		}
	}

	.poll-questions {
		padding: 37px 0 45px 0;

		@media (max-width: 768px) {
			background-color: color(white);
			border: 1px solid color(gray-slider);
			border-radius: 9px;
			width:375px;
			overflow-x:scroll;
    	overflow-y:hidden;
			flex-direction: column;
			height: auto;
			}
	}

	.question-children {
		border-bottom: 1px solid;
		display: none !important;
		padding-bottom: 30px;

		&.display-grid {
			display: grid !important;
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/polls/page-polls.vue